import drEasyApi from "./Customapi";


export const fetchCenterServices = async () => {
  try {
    const response = await drEasyApi.get(`/api/Services/GetMyServices`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};